import { addPartnerPaymentSource } from './addPartnerPaymentSource';
import { chargePartner } from './chargePartner';
import { createPartner } from './createPartner';
import { createPartnerHours } from './createPartnerHours';
import { createPartnerUser } from './createPartnerUser';
import { downloadRidesByDeactivatedPartnerCallers } from './downloadRidesByDeactivatedPartnerCallers';
import { fetchNumberOfRidesTakenPerPartner } from './fetchNumberOfRidesTakenPerPartner';
import { fetchPartners } from './fetchPartners';
import { fetchPartnerNumbersAndMainPartnershipNumber } from './fetchPartnerNumbersAndMainPartnershipNumber';
import { fetchPartnerRideHistoryReport } from './fetchPartnerRideHistoryReport';
import { fetchPartner } from './fetchPartner';
import { fetchPartnerSubsidyLocations } from './fetchPartnerSubsidyLocations';
import { generatePartnerLogoUploadPresignedUrl } from './generatePartnerLogoUploadPresignedUrl';
import { generatePartnerWelcomeMessageUploadPresignedUrl } from './generatePartnerWelcomeMessageUploadPresignedUrl';
import { getPartnerCallLogStats } from './getPartnerCallLogStats';
import { getRidesByDeactivatedPartnerCallers } from './getRidesByDeactivatedPartnerCallers';
import { partnerGeofenceContains } from './partnerGeofenceContains';
import { updatePartner } from './updatePartner';
import { updatePartnerUser } from './updatePartnerUser';
import { associateAsPartnerUser } from './associateAsPartnerUser';
import { removeAsPartnerUser } from './removeAsPartnerUser';
import { fetchPartnerBudget } from './fetchPartnerBudget';

export const partnerService = {
  addPartnerPaymentSource,
  chargePartner,
  createPartner,
  createPartnerHours,
  createPartnerUser,
  downloadRidesByDeactivatedPartnerCallers,
  fetchNumberOfRidesTakenPerPartner,
  fetchPartners,
  fetchPartnerNumbersAndMainPartnershipNumber,
  fetchPartnerRideHistoryReport,
  fetchPartner,
  fetchPartnerSubsidyLocations,
  generatePartnerLogoUploadPresignedUrl,
  generatePartnerWelcomeMessageUploadPresignedUrl,
  getPartnerCallLogStats,
  getRidesByDeactivatedPartnerCallers,
  partnerGeofenceContains,
  updatePartner,
  updatePartnerUser,
  associateAsPartnerUser,
  removeAsPartnerUser,
  fetchPartnerBudget,
};
